// SectionHeader.tsx
import React, { useState } from "react";
import Pluseicon from "../../static/svg/Pluseicon";
import Knowledgeicon from "../../static/svg/Knowledgeicon";
import { IconButton } from "@mui/material";
import { useTheme } from "../../../context/ThemeContext";
import { useLocation, useNavigate } from "react-router-dom";
import Backicon from "../../static/svg/Backicon";
import { Button } from "bootstrap";
import FIlterIcon from "../../static/svg/FIlterIcon";
import Modalpopup from "../atoms/Modalpopup";
import AccessControl from "./AccessControl";
import RevertIcon from "../../static/svg/RevertIcon";

interface PermissionTypes {
  create?: boolean;
  read?: boolean;
  update?: boolean;
  delete?: boolean;
}

interface SectionHeaderProps {
  title: string;
  onAdd?: () => void;
  action?: string;
  trainingSpace?: boolean;
  train?: boolean;
  filter?: () => void;
  link?: string;
  back?: boolean;
  complete?: () => void;
  revert?: () => void;
  revertBack?: boolean;
  phase?: number;
  //crews
  crewAnalyzedRecords?: boolean;
  crewPreparedRecords?: boolean;
  crewBuild?: boolean;
  crewSpace?: boolean;
  crewFineTune?: boolean;
  crewAnalyze?: boolean;
  crewPreparePhase?: boolean;
  trainingCrew?: boolean;

  //knowledge-hubs
  spaceAnalyzedRecords?: boolean;
  spacePreparedRecords?: boolean;
  spaceAnalyzePhase?: boolean;
  spacePreparePhase?: boolean;
  spaceFineTune?: boolean;

  permissionName?: string;
  permissionTypes?: (keyof PermissionTypes)[];
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  onAdd,
  trainingSpace,
  action,
  train,
  link,
  back,
  filter,
  complete,
  phase,
  revert,
  revertBack,
  //crews
  crewAnalyzedRecords,
  crewPreparedRecords,
  crewBuild,
  crewSpace,
  crewFineTune,
  crewAnalyze,
  crewPreparePhase,
  trainingCrew,

  //knowledge-hubs
  spaceAnalyzedRecords,
  spacePreparedRecords,
  spaceAnalyzePhase,
  spacePreparePhase,
  spaceFineTune,
  permissionName,
  permissionTypes,
}) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const location = useLocation();
  const isAISpace = location.pathname.includes("/ai_space");

  const navigate = useNavigate();
  // Handle click event for the link, call onAdd if provided
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onAdd) {
      e.preventDefault();
      onAdd();
    }
  };
  const handleBack = () => {
    navigate(-1);
  };
  const isPhaseCompleted = () => {
    if (!phase) return false;

    if (crewAnalyze || spaceAnalyzePhase) {
      return phase >= 1;
    }

    if (crewPreparePhase || spacePreparePhase) {
      return phase >= 2;
    }

    if (crewBuild) {
      return phase >= 3;
    }

    if (trainingCrew || crewSpace || trainingSpace) {
      return phase >= 4;
    }

    if (crewFineTune || spaceFineTune) {
      return phase >= 5;
    }

    if (crewAnalyzedRecords || spaceAnalyzedRecords) {
      return phase >= 1;
    }

    if (crewPreparedRecords || spacePreparedRecords) {
      return phase >= 2;
    }

    return false;
  };

  const showfilter = location.pathname.includes("/logs");
  return (
    <div className="title--layout">
      <div className="my-3">
        <header
          className={`Top_bar ${
            isAISpace && isDarkMode ? "bg-dark" : "bg-white"
          } px-1 py-1`}
        >
          <div className="navbar navbar-expand-lg navbar-light fw-bold">
            <div className="container-fluid d-flex align-items-center">
              <div className="navbarbrand">{title}</div>
              <div className="d-flex align-items-center gap-3">
                {complete &&
                  (isPhaseCompleted() ? (
                    <div className="d-flex align-items-center gap-3">
                    
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#60cd60",
                          color: "white",
                          padding: "6px 10px",
                          borderRadius: "4px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          cursor: "default",
                        }}
                      >
                        Completed
                      </div>
                      <span className="cursor-pointer" title="Revert" onClick={revert}>
                        <RevertIcon/>
                      </span>
                    </div>
                  ) : (
                    <button
                      className="btn btn-secondary me-2 cursor-pointer"
                      onClick={complete}
                    >
                      Complete
                    </button>
                  ))}
                {back && (
                  <div
                    className="cursor-pointer"
                    title="Back"
                    aria-disabled={phase === 1 ? true : false}
                    onClick={handleBack}
                  >
                    <Backicon />
                  </div>
                )}
                {permissionName && permissionTypes ? (
                  <AccessControl
                    requiredPermissions={[
                      { permission: permissionName, types: permissionTypes },
                    ]}
                    renderNoAccess={<></>}
                  >
                    {trainingSpace || train ? (
                      <a
                      
                        href={link}
                        onClick={handleClick}
                        className="text-decoration-none cursor-pointer"
                        title={train ? action : "Trained records"}
                      >
                        <Knowledgeicon />
                      </a>
                    ) : onAdd ? (
                      <a
                        href={link}
                        onClick={handleClick}
                        className="text-decoration-none cursor-pointer"
                        title={action}
                      >
                        <Pluseicon />
                      </a>
                    ) : null}
                  </AccessControl>
                ) : trainingSpace || train ? (
                  <a
                    href={link}
                    onClick={handleClick}
                    className="text-decoration-none cursor-pointer"
                    title={train ? action : "Trained records"}
                  >
                    <Knowledgeicon />
                  </a>
                ) : onAdd ? (
                  <a
                    href={link}
                    onClick={handleClick}
                    className="text-decoration-none cursor-pointer"
                    title={action}
                  >
                    <Pluseicon />
                  </a>
                ) : null}
                {showfilter && <div className="cursor-pointer" onClick={filter}>
                  <FIlterIcon />
                </div>}
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};

export default SectionHeader;
